
export default {

    props: [
        'itemid',
        'itemType'
    ],

    created() {
        this.$nuxt.$on("successfully-logged", data => {
            if (data && data.next === 'showCommentForm' && data.props.itemId == this.itemid) {
                this.toggleCommentForm();
            }
        });
    },

    beforeDestroy() {
        this.$nuxt.$off('successfully-logged');
    },

    methods: {
        toggleCommentForm() {

            if (this.$auth.loggedIn) {
                this.$emit("toggle-comment-form", this.itemid);
            }
            else {
                this.$nuxt.$emit("open-login-modal", {
                    mode: 'login',
                    next: 'showCommentForm',
                    props: { itemId: this.itemid }
                });
            }
        }
    }

}
